import {Observable} from 'rxjs/Observable';
import {Reason, Reasons} from "../reason";
import {HttpClient} from "@angular/common/http";

export const OTHER_REASON :Reason = {id: 4, name: "Other", specify: true};

export const REASON_GROUP_ID_REGISTRATION = 0;
export const REASON_GROUP_ID_REJECT_APPLICANT = 1;
export const REASON_GROUP_ID_ARCHIVED_APPLICANT = 5;
export const REASON_GROUP_ID_ON_HOLD_APPLICANT = 6;

export abstract class ReasonsService {

    private allReasonsMap: Map<number,  Array<Reason>> = new Map<number, Array<Reason>>();
    private activeReasonsMap: Map<number,  Array<Reason>> = new Map<number, Array<Reason>>();

    constructor(private _http: HttpClient, private context) {
    }

    getActiveReasonsByGroupId(groupId: number): Observable<Array<Reason>> {
        return this.getReasons(`/api/${this.context}/dictionary/reasons/${groupId}`, groupId, this.activeReasonsMap);
    }

    getAllReasonsByGroupId(groupId: number): Observable<Array<Reason>> {
        return this.getReasons(`/api/${this.context}/dictionary/reasons/${groupId}?all`, groupId, this.allReasonsMap);
    }

    getOtherAsUniqueReason(): Observable<Array<Reason>> {
        let otherReasonArray: Array<Reason> = [];
        otherReasonArray.push(OTHER_REASON);
        return Observable.of(otherReasonArray);
    }
    
    private getReasons(url: string, groupId: number, cache:  Map<number, Array<Reason>>): Observable<Array<Reason>> {
        if (cache.has(groupId)) {
            return Observable.of(cache.get(groupId));
        }
        return this._http.get<Reasons>(url)
            .map(response => {
                let reasons = response.reasons;
                cache.set(groupId, reasons);
                return reasons;
            });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/reasons.service.ts